import React from 'react';
import { Icon } from '../../../base/components/Icon';
import { Area } from '../../../base/interfaces/config';
import { getAreaIconById } from '../../../base/utils';
import { __t } from '../../../base/utils/t';
import { HelperModal } from '../../../base/components/HelperModal';

import './styles.scss';

interface Props {
    title: string;
    areas: Area[];
    selectedAreas: Area[];
    className?: string;
    selectHandler: (value: Area[]) => void;
}

export const AreasSelect = ({ title, areas, selectedAreas, className = '', selectHandler }: Props) => {
    const selectAllHandler = () => selectHandler([]);

    const tabClickHandler = (area: Area) => {
        if (selectedAreas.some((i) => i.id === area.id)) {
            selectHandler(selectedAreas.filter((i) => i.id !== area.id));
            return;
        }

        selectHandler([...selectedAreas, area]);
    };

    return (
        <div className={`application-areas-select ${className}`}>
            <h1 className='application-areas-select__title'>{title}</h1>
            <div className='application-areas-select__top-wrap'>
                <div
                    className={`application-areas-select__select-tab ${
                        !selectedAreas.length ? 'application-areas-select__select-tab--selected' : ''
                    }`}
                    onClick={selectAllHandler}
                >
                    <Icon
                        icon='user-helmet-safety-light'
                        className='application-areas-select__select-tab-icon'
                        size='24px'
                    />
                    {__t('Все сферы')}
                </div>
                <HelperModal icon='info-circle' className='application-areas-select__select-helper-modal'>
                    {__t('Вы можете выбрать Все сферы, одну или несколько сфер')}
                </HelperModal>
            </div>
            <div className='application-areas-select__select-tabs-container application-areas-select__select-tabs-container--areas'>
                {[...areas]
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((area) => (
                        <div key={area.id}>
                            <div
                                className={`application-areas-select__select-tab ${
                                    selectedAreas.some((c) => c.id === area.id)
                                        ? 'application-areas-select__select-tab--selected'
                                        : ''
                                }`}
                                onClick={() => tabClickHandler(area)}
                            >
                                <Icon
                                    icon={getAreaIconById(area.id)}
                                    className='application-areas-select__select-tab-icon'
                                    size='24px'
                                />
                                {area.name}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};
